import favoriteRecipes from "./favoriteRecipesReducer"

export default {
    favoriteRecipes,
}
